<template>
    <el-menu :collapse="collapse">
        <template v-for="a in dataList">
            <el-menu-item v-if="!a.children?.length" :key="a.path" :index="a.path" @click="$emit('onClick', a)">
                <Icon v-if="a.meta?.icon" :icon="a.meta?.icon" />
                <span>{{ a.meta?.title || a.name }}</span>
            </el-menu-item>
            <el-submenu v-else :key="'s' + a.path" :index="a.path">
                <template slot="title">
                    <Icon v-if="a.meta?.icon" :icon="a.meta?.icon" />
                    <span>{{ a.meta?.title || a.name }}</span>
                </template>
                <template v-for="b in a.children">
                    <el-menu-item v-if="!b.children?.length" :key="b.path" :index="b.path" @click="$emit('onClick', b)">
                        <Icon v-if="b.meta?.icon" :icon="b.meta?.icon" />
                        <span>{{ b.meta?.title || b.name }}</span>
                    </el-menu-item>
                    <el-submenu v-else :key="'s' + b.path" :index="b.path">
                        <template slot="title">
                            <i class="el-icon-menu"></i>
                            <Icon v-if="b.meta?.icon" :icon="b.meta?.icon" />
                            <span>{{ b.meta?.title || b.name }}</span>
                        </template>
                        <template v-for="c in b.children">
                            <el-menu-item v-if="!c.children?.length" :key="c.path" :index="c.path" @click="$emit('onClick', c)">
                                <Icon v-if="c.meta?.icon" :icon="c.meta?.icon" />
                                <span>{{ c.meta?.title || c.name }}</span>
                            </el-menu-item>
                            <el-submenu v-else :key="'s' + c.path" :index="c.path">
                                <template slot="title">
                                    <i class="el-icon-menu"></i>
                                    <Icon v-if="c.meta?.icon" :icon="c.meta?.icon" />
                                    <span>{{ c.meta?.title || c.name }}</span>
                                </template>
                                <template v-for="d in c.children">
                                    <el-menu-item v-if="!d.children?.length" :key="d.path" :index="d.path" @click="$emit('onClick', d)">
                                        <Icon v-if="d.meta?.icon" :icon="d.meta?.icon" />
                                        <span>{{ d.meta?.title || d.name }}</span>
                                    </el-menu-item>
                                    <el-submenu v-else :key="'s' + d.path" :index="d.path">
                                        <template slot="title">
                                            <i class="el-icon-menu"></i>
                                            <Icon v-if="d.meta?.icon" :icon="d.meta?.icon" />
                                            <span>{{ d.meta?.title || d.name }}</span>
                                        </template>
                                        <el-menu-item v-for="e in d.children" :key="e.path" :index="e.path" @click="$emit('onClick', e)">
                                            <Icon v-if="e.meta?.icon" :icon="e.meta?.icon" />
                                            <span>{{ e.meta?.title || e.name }}</span>
                                        </el-menu-item>
                                    </el-submenu>
                                </template>
                            </el-submenu>
                        </template>
                    </el-submenu>
                </template>
            </el-submenu>
        </template>
    </el-menu>
</template>
<script>
export default {
    name: 'el-menu-tree',
    props: ['collapse', 'dataList']
}
</script>